import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import moment from 'moment';

//Admin
import * as Company from './Company';
import * as CompanyUser from './CompanyUser';
import * as ExternalContractor from './ExternalContractor';
import * as CompanyTeam from './CompanyTeam';
import * as WorkflowStatus from './WorkflowStatus';
import * as WorkflowStatusPreset from './WorkflowStatusPreset';
import * as SubWorkflow from './SubWorkflow';
import * as ChecklistTemplate from './ChecklistTemplate';
import * as ChecklistTemplatePreset from './ChecklistTemplatePreset';
import * as MailMergeTemplate from './MailMergeTemplate';
import * as DocumentType from './DocumentType';
import * as NoteTemplate from './NoteTemplate';
import * as QuoteTemplate from './QuoteTemplate';
import * as SmsTemplate from './SmsTemplate';
import * as CompanyDocumentFolder from './CompanyDocumentFolder';
import * as JobApprovedDocGroupTemplate from './JobApprovedDocGroupTemplate';
import * as AdjoiningPropertyDefaultDocumentFolder from './AdjoiningPropertyDefaultDocumentFolder';
import * as CompanyChecklistFolder from './CompanyChecklistFolder';
import * as AppIntegration from './AppIntegration';
import * as TaskTemplate from './TaskTemplate';
import * as LineItem from './LineItem';
import * as LineItemPreset from './LineItemPreset';
import * as Label from './Label';
import * as ClientCategoryLabel from './ClientCategoryLabel';
import * as SubJobLabelOption from './SubJobLabelOption';
import * as JobColorOption from './JobColorOption';
import * as JobType from './JobType';
import * as WorkTypeOption from './WorkTypeOption';
import * as QuoteRejectedReasonOption from './QuoteRejectedReasonOption';
import * as NccBuildingClassificationTemplate from './NccBuildingClassificationTemplate';
import * as CompanyContact from './CompanyContact';
import * as ApprovalConditionTemplate from './ApprovalConditionTemplate';
import * as ApprovalConditionTemplatePreset from './ApprovalConditionTemplatePreset';
import * as ApprovalAdviceNoteTemplate from './ApprovalAdviceNoteTemplate';
import * as ApprovalAdviceNoteTemplatePreset from './ApprovalAdviceNoteTemplatePreset';
import * as AspectCertificateTemplate from './AspectCertificateTemplate';
import * as AspectCertificateTemplatePreset from './AspectCertificateTemplatePreset';
import * as PerformanceSolutionTemplate from './PerformanceSolutionTemplate';
import * as PerformanceSolutionTemplatePreset from './PerformanceSolutionTemplatePreset';
import * as ReportingAuthorityTemplate from './ReportingAuthorityTemplate';
import * as ReportingAuthorityTemplatePreset from './ReportingAuthorityTemplatePreset';
import * as ExemptionPartialComplianceTemplate from './ExemptionPartialComplianceTemplate';
import * as CompanyEmailTemplate from './CompanyEmailTemplate';
import * as CombinedAllotmentDeterminationTemplate from './CombinedAllotmentDeterminationTemplate';
import * as BuildingWorkEnforcementTemplate from './BuildingWorkEnforcementTemplate';
import * as ActionPack from './ActionPack';
import * as EssentialServiceTemplate from './EssentialServiceTemplate';
import * as CouncilApplicationType from './CouncilApplicationType';
import * as Lga from './Lga';
import * as ChecklistStatus from './ChecklistStatus';
import * as SubJobType from './SubJobType';
import * as SubJobTypePreset from './SubJobTypePreset';
import * as JobApprovedDocTemplate from './JobApprovedDocTemplate';
import * as JobApprovedDocTemplatePreset from './JobApprovedDocTemplatePreset';
import * as SubJobDirectionTemplate from './SubJobDirectionTemplate';
import * as CompanyOffice from './CompanyOffice';
import * as Region from './Region';
import * as Client from './Client';
import * as ClientUser from './ClientUser';
import * as RequiredCertificateTemplate from './RequiredCertificateTemplate';
import * as RequiredCertificateTemplatePreset from './RequiredCertificateTemplatePreset';
import * as StampConfig from './StampConfig';
import * as Report from './Report';
import * as DocumentLibrary from './DocumentLibrary';
import * as Vic30aTemplate from './Vic30aTemplate';
import * as AutoNotification from './AutoNotification';
import * as SystemNotification from './SystemNotification';
import * as PlanningCodeOption from './PlanningCodeOption';
import * as PlanningApplicationType from './PlanningApplicationType';
import * as OverlayOption from './OverlayOption';
import * as FireSafetyMeasureTemplate from './FireSafetyMeasureTemplate';
import * as WorkDescriptionOption from './WorkDescriptionOption';
import * as WorkDescriptionMapping from './WorkDescriptionMapping';
import * as NccClassBuildingPartOption from './NccClassBuildingPartOption';
import * as CompanyRoleMenu from './CompanyRoleMenu';
import * as DocumentNameTemplate from './DocumentNameTemplate';
import * as ClientJobTemplate from './ClientJobTemplate';
import * as ClientJobTemplateContact from './ClientJobTemplateContact';
import * as ClientJobTemplateNccClass from './ClientJobTemplateNccClass';
import * as ClientJobTemplateChecklist from './ClientJobTemplateChecklist';
import * as SubJobBlockDates from './SubJobBlockDates';
import * as JobStatusStepper from './JobStatusStepper';
import * as AssessmentChecklistTemplate from './AssessmentChecklistTemplate';
import * as JobDataTemplate from './JobDataTemplate';
import * as JobDataTemplateContact from './JobDataTemplateContact';
import * as CouncilApplicationPreset from './CouncilApplicationPreset';
import * as DocumentStatus from './DocumentStatus';
import * as BillableTaskTemplate from './BillableTaskTemplate';
import * as BillableTaskTemplatePreset from './BillableTaskTemplatePreset';
import * as AIPromptTemplate from './AIPromptTemplate';
import * as AiVectorStore from './AiVectorStore';
import * as ServiceRequestType from './ServiceRequestType';
import * as ServiceRequestStatus from './ServiceRequestStatus';
import * as SubJobResultOption from './SubJobResultOption';
import * as SubJobInternalNoteTemplate from './SubJobInternalNoteTemplate';
import * as ServiceRequestNoteTemplate from './ServiceRequestNoteTemplate';
import * as JobListTab from './JobListTab';


//Business
import * as Job from './Job';
import * as Property from './Property';
import * as JobMultiUnit from './JobMultiUnit';
import * as JobContact from './JobContact';
import * as JobNote from './JobNote';
import * as JobTask from './JobTask';
import * as Quote from './Quote';
import * as Invoice from './Invoice';
import * as JobChecklist from './JobChecklist';
import * as Document from './Document';
import * as SubJob from './SubJob';
import * as JobStatusChange from './JobStatusChange';
import * as JobNccClass from './JobNccClass';
import * as Approval from './Approval';
import * as ApprovalAmendment from './ApprovalAmendment';
import * as ApprovalCondition from './ApprovalCondition';
import * as ApprovalAdviceNote from './ApprovalAdviceNote';
import * as ApprovalPerformanceSolution from './ApprovalPerformanceSolution';
import * as ApprovalReportingAuthority from './ApprovalReportingAuthority';
import * as ApprovalBabDetermination from './ApprovalBabDetermination';
import * as ApprovalExemptionPartialCompliance from './ApprovalExemptionPartialCompliance';
import * as ApprovalVariation from './ApprovalVariation';
import * as EssentialService from './EssentialService';
import * as CouncilApplication from './CouncilApplication';
import * as SubJobChecklist from './SubJobChecklist';
import * as JobApprovedDoc from './JobApprovedDoc';
import * as JobRequiredCertificate from './JobRequiredCertificate';
import * as JobAspectCertificate from './JobAspectCertificate';
import * as AdjoiningProperty from './AdjoiningProperty';
import * as MandatorySubJob from './MandatorySubJob';
import * as BuildingWorkEnforcement from './BuildingWorkEnforcement';
import * as CombinedAllotment from './CombinedAllotment';
import * as PoolSpa from './PoolSpa';
import * as JobOverlay from './JobOverlay';
import * as JobPlanningCode from './JobPlanningCode';
import * as JobPlanningInstrument from './JobPlanningInstrument';
import * as ProposedDevelopment from './ProposedDevelopment';
import * as FireSafetyMeasure from './FireSafetyMeasure';
import * as Complaint from './Complaint';
import * as JobAssessmentChecklist from './JobAssessmentChecklist';
import * as BillableTask from './BillableTask';
import * as ServiceRequest from './ServiceRequest';
import * as ServiceRequestList from './ServiceRequestList';
import * as CertifierWorkload from './CertifierWorkload';


//其他Section级js都引用进来
const sections = {
  //Admin
  'Company': Company,
  'ServiceRequest': ServiceRequest,
  'ServiceRequestList': ServiceRequestList,
  'CertifierWorkload': CertifierWorkload,
  'ServiceRequestType': ServiceRequestType,
  'ServiceRequestStatus': ServiceRequestStatus,
  'CompanyUser': CompanyUser,
  'ExternalContractor': ExternalContractor,
  'CompanyTeam': CompanyTeam,
  'WorkflowStatus': WorkflowStatus,
  'WorkflowStatusPreset': WorkflowStatusPreset,
  'SubWorkflow': SubWorkflow,
  'ChecklistTemplate': ChecklistTemplate,
  'ChecklistTemplatePreset': ChecklistTemplatePreset,
  'MailMergeTemplate': MailMergeTemplate,
  'DocumentType': DocumentType,
  'NoteTemplate': NoteTemplate,
  'QuoteTemplate': QuoteTemplate,
  'SmsTemplate': SmsTemplate,
  'CompanyDocumentFolder': CompanyDocumentFolder,
  'JobApprovedDocGroupTemplate': JobApprovedDocGroupTemplate,
  'AdjoiningPropertyDefaultDocumentFolder': AdjoiningPropertyDefaultDocumentFolder,
  'CompanyChecklistFolder': CompanyChecklistFolder,
  'AppIntegration': AppIntegration,
  'TaskTemplate': TaskTemplate,
  'LineItem': LineItem,
  'LineItemPreset': LineItemPreset,
  'Label': Label,
  'ClientCategoryLabel': ClientCategoryLabel,
  'SubJobLabelOption': SubJobLabelOption,
  'JobColorOption': JobColorOption,
  'JobType': JobType,
  'WorkTypeOption': WorkTypeOption,
  'QuoteRejectedReasonOption': QuoteRejectedReasonOption,
  'NccBuildingClassificationTemplate': NccBuildingClassificationTemplate,
  'CompanyContact': CompanyContact,
  'ApprovalConditionTemplate': ApprovalConditionTemplate,
  'ApprovalConditionTemplatePreset': ApprovalConditionTemplatePreset,
  'ApprovalAdviceNoteTemplate': ApprovalAdviceNoteTemplate,
  'ApprovalAdviceNoteTemplatePreset': ApprovalAdviceNoteTemplatePreset,
  'AspectCertificateTemplate': AspectCertificateTemplate,
  'AspectCertificateTemplatePreset': AspectCertificateTemplatePreset,
  'PerformanceSolutionTemplate': PerformanceSolutionTemplate,
  'PerformanceSolutionTemplatePreset': PerformanceSolutionTemplatePreset,
  'ReportingAuthorityTemplate': ReportingAuthorityTemplate,
  'ReportingAuthorityTemplatePreset': ReportingAuthorityTemplatePreset,
  'ExemptionPartialComplianceTemplate': ExemptionPartialComplianceTemplate,
  'CompanyEmailTemplate': CompanyEmailTemplate,
  'CombinedAllotmentDeterminationTemplate': CombinedAllotmentDeterminationTemplate,
  'BuildingWorkEnforcementTemplate': BuildingWorkEnforcementTemplate,
  'ActionPack': ActionPack,
  'EssentialServiceTemplate': EssentialServiceTemplate,
  'CouncilApplicationType': CouncilApplicationType,
  'Lga': Lga,
  'ChecklistStatus': ChecklistStatus,
  'SubJobType': SubJobType,
  'SubJobTypePreset': SubJobTypePreset,
  'JobApprovedDocTemplate': JobApprovedDocTemplate,
  'JobApprovedDocTemplatePreset': JobApprovedDocTemplatePreset,
  'SubJobDirectionTemplate': SubJobDirectionTemplate,
  'CompanyOffice': CompanyOffice,
  'Region': Region,
  'Client': Client,
  'ClientUser': ClientUser,
  'RequiredCertificateTemplate': RequiredCertificateTemplate,
  'RequiredCertificateTemplatePreset': RequiredCertificateTemplatePreset,
  'StampConfig': StampConfig,
  'Report': Report,
  'DocumentLibrary': DocumentLibrary,
  'Vic30aTemplate': Vic30aTemplate,
  'AutoNotification': AutoNotification,
  'SystemNotification': SystemNotification,
  'PlanningCodeOption': PlanningCodeOption,
  'PlanningApplicationType': PlanningApplicationType,
  'OverlayOption': OverlayOption,
  'FireSafetyMeasureTemplate': FireSafetyMeasureTemplate,
  'WorkDescriptionOption': WorkDescriptionOption,
  'WorkDescriptionMapping': WorkDescriptionMapping,
  'NccClassBuildingPartOption': NccClassBuildingPartOption,
  'CompanyRoleMenu': CompanyRoleMenu,
  'DocumentNameTemplate': DocumentNameTemplate,
  'ClientJobTemplate': ClientJobTemplate,
  'ClientJobTemplateContact': ClientJobTemplateContact,
  'ClientJobTemplateNccClass': ClientJobTemplateNccClass,
  'ClientJobTemplateChecklist': ClientJobTemplateChecklist,
  'SubJobBlockDates': SubJobBlockDates,
  'JobStatusStepper': JobStatusStepper,
  'AssessmentChecklistTemplate': AssessmentChecklistTemplate,
  'JobDataTemplate': JobDataTemplate,
  'JobDataTemplateContact': JobDataTemplateContact,
  'CouncilApplicationPreset': CouncilApplicationPreset,
  'DocumentStatus': DocumentStatus,
  'BillableTaskTemplate': BillableTaskTemplate,
  'BillableTaskTemplatePreset': BillableTaskTemplatePreset,
  'AIPromptTemplate': AIPromptTemplate,
  'AiVectorStore': AiVectorStore,
  'SubJobResultOption': SubJobResultOption,
  'SubJobInternalNoteTemplate': SubJobInternalNoteTemplate,
  'ServiceRequestNoteTemplate': ServiceRequestNoteTemplate,
  'JobListTab': JobListTab,



  //Business
  'Job': Job,
  'Property': Property,
  'JobMultiUnit': JobMultiUnit,
  'JobContact': JobContact,
  'JobNote': JobNote,
  'JobTask': JobTask,
  'Quote': Quote,
  'Invoice': Invoice,
  'JobChecklist': JobChecklist,
  'Document': Document,
  'SubJob': SubJob,
  'JobStatusChange': JobStatusChange,
  'JobNccClass': JobNccClass,
  'Approval': Approval,
  'ApprovalAmendment': ApprovalAmendment,
  'ApprovalCondition': ApprovalCondition,
  'ApprovalAdviceNote': ApprovalAdviceNote,
  'ApprovalPerformanceSolution': ApprovalPerformanceSolution,
  'ApprovalReportingAuthority': ApprovalReportingAuthority,
  'ApprovalBabDetermination': ApprovalBabDetermination,
  'ApprovalExemptionPartialCompliance': ApprovalExemptionPartialCompliance,
  'ApprovalVariation': ApprovalVariation,
  'EssentialService': EssentialService,
  'CouncilApplication': CouncilApplication,
  'SubJobChecklist': SubJobChecklist,
  'JobApprovedDoc': JobApprovedDoc,
  'JobRequiredCertificate': JobRequiredCertificate,
  'JobAspectCertificate': JobAspectCertificate,
  'AdjoiningProperty': AdjoiningProperty,
  'MandatorySubJob': MandatorySubJob,
  'BuildingWorkEnforcement': BuildingWorkEnforcement,
  'CombinedAllotment': CombinedAllotment,
  'PoolSpa': PoolSpa,
  'JobOverlay': JobOverlay,
  'JobPlanningCode': JobPlanningCode,
  'JobPlanningInstrument': JobPlanningInstrument,
  'ProposedDevelopment': ProposedDevelopment,
  'FireSafetyMeasure': FireSafetyMeasure,
  'Complaint': Complaint,
  'JobAssessmentChecklist': JobAssessmentChecklist,
  'BillableTask': BillableTask,
};

//调用函数的主入口, e是触发事件
export function operationalFunction({ e, functionName, configParameter, sectionName, parameter, data, formComponent, sectionComponent, pageComponent, uie, callback, showError = true, loadData = true } = {}) {
  // console.log(functionName, sectionName, parameter, formComponent, sectionComponent, pageComponent, uie, callback);
  sectionName = sectionName || null;
  try {
    // 顶部过滤器改变查询条件后，下一次列表刷新必须从第一页开始。
    if (uie?.isTopFilter && sectionComponent != null) {
      sectionComponent.resetPaginationOnNextLoad = true;
      if (Array.isArray(sectionComponent.child)) {
        sectionComponent.child.forEach(child => {
          if (child.current != null) child.current.resetPaginationOnNextLoad = true;
        });
      }
    }
    const sectionFunctions = sectionName != null ? sections[sectionName] : null;
    if (functionName != null && typeof sectionFunctions?.[functionName] === 'function') {
      sectionFunctions[functionName]({ e: e, parameter: parameter, configParameter: configParameter, data: data, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie, loadData: loadData });
    } else if (functionName != null && typeof eval(functionName) === 'function') {
      eval(functionName)({ e: e, parameter: parameter, configParameter: configParameter, data: data, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie, loadData: loadData })
    }
    if (typeof callback === 'function') {
      callback.call(parameter, formComponent, sectionComponent, pageComponent, sectionName, uie);
    }
  } catch (error) {
    if (showError) {
      console.error(
        'Run function "' + functionName + '" in Common or ' + sectionName + ' section failed.',
        error
      );
    }
    // globalFunction.handleError(error, pageComponent);
  }
}

//通用的点击添加按钮逻辑, 打开渲染表单Modal并设置为Create
function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的点击添加按钮逻辑');
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  sectionComponent.setState({ formReadOnly: false, formReadOnlyEditableSources: [] }); // 新增表单始终可编辑，重置只读状态避免从只读编辑切换残留
  pageComponent.setState({ selectedDocumentList: [] });

  // 提前给uie做预设
  switch (sectionComponent.state.section.name) {
    case 'BuildingWorkEnforcement':
      globalFunction.setUieVisible(pageComponent, 'BuildingWorkEnforcement', 'Create', 'RelevantEnforcementId', false);
      break;
    case 'JobContact':
      sectionComponent.customForm.current?.formRef?.current?.resetFields();
      break;
  }

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false, currentDataKey: 0 });
    sectionComponent.customForm.current?.getComponentDataSource();
    // sectionComponent.customForm.current?.formRef.current?.resetFields();
    if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
      if (sectionComponent.customForm.current?.formRef.current?.getFieldValue('QuoteLineItemList') !== undefined) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('QuoteLineItemList', undefined);
      }
      if (sectionComponent.customForm.current?.formRef.current?.getFieldValue('InvoiceLineItemList') !== undefined) {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('InvoiceLineItemList', undefined);
      }
    }
    setTimeout(() => {
      let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
      sectionComponent.props.section.componentList.filter(c => c.type === 'Create')[0].groupList.forEach(group => {
        group.uieList.forEach(uie => {
          switch (uie.component) {
            case 'Select':
              let selectValue = null;
              if (componentDataSource[uie.source] !== undefined) {
                if (uie.type === 'group') {
                  componentDataSource[uie.source].some(group => {
                    if (group.SelectOptionList === null) {
                      selectValue = group.Value;
                      return true;
                    }
                    if (uie.required) {
                      return group.SelectOptionList.some(selectOption => {
                        selectValue = selectOption.Value;
                        return true;
                      });
                    }
                  });
                } else {
                  if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                    selectValue = componentDataSource[uie.source][0].Value;
                  }
                  if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                    selectValue = [];
                  }
                }
              }
              if (uie.autoSelect) {
                //如果是自定义AutoSelect的类型, 触发其onChange事件
                if (componentDataSource[uie.source] !== undefined) {
                  operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: selectValue, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                }
              } else {
                //处理Select默认选项, 如果字段的备选项列表已加载, 则自动选择备选项里第一个
                if (componentDataSource[uie.source] !== undefined) {
                  sectionComponent.customForm.current?.formRef.current?.setFieldValue(uie.source, selectValue);
                }
              }
              break;

            case 'ColorPicker':
              let defaultColor = ''
              if (uie.source === 'BackgroundColor') {
                defaultColor = config.component.ColorPicker.defaultColor
              } else {
                defaultColor = config.component.fontColor.defaultColor
              }
              sectionComponent.customForm.current?.formRef.current?.setFieldValue(uie.source, defaultColor);
              break;
          }
        });
      });

      let functionName = 'add' + sectionName + 'PopUpRun';
      try {
        if (typeof sections[sectionName][functionName] === 'function') {
          sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
        }
      } catch (error) { }
      sectionComponent.setState({ isFormModified: false });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//通用的点击编辑按钮逻辑, 打开渲染表单Modal并设置为Edit
function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的点击编辑按钮逻辑');
  if (sectionName === 'Invoice' || sectionName === 'Quote') {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ autoAppendLineItemIndexes: [] });
  }
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  sectionComponent.setState({ formReadOnly: false, formReadOnlyEditableSources: [] }); // 每次打开先重置只读状态，避免上次的锁定残留
  pageComponent.setState({ selectedDocumentList: [] });

  // 提前给uie做预设
  switch (sectionComponent.state.section.name) {
    case 'BuildingWorkEnforcement':
      globalFunction.setUieVisible(pageComponent, 'BuildingWorkEnforcement', 'Edit', 'RelevantEnforcementId', false);
      break;
  }

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          // CompanyId=3：已审批(Status=1)的发票，权限<44 的用户只读打开（整表禁用 + 禁止提交），后端 EditAsync 另有强制校验
          if (sectionName === 'Invoice'
            && pageComponent.props.authUser?.CompanyId === 3
            && data.data.Status === 1
            && pageComponent.props.authUser?.MaxPermissionLevel < 44) {
            sectionComponent.setState({ formReadOnly: true });
          }
          //处理不适合antd组件的数据
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
            group.uieList.forEach(uie => {
              switch (uie.component) {
                case 'DatePicker':
                  //处理日期, 把字符串转成moment
                  if (data.data[uie.source] !== null && data.data[uie.source] !== undefined) {
                    data.data[uie.source] = moment(data.data[uie.source], config.format.date);
                  } else {
                    data.data[uie.source] = undefined;
                  }

                  //根据财年处理是否disabled
                  if (uie.type === 'financial' && !(pageComponent.props.authUser.MaxPermissionLevel >= 100) && data.data[uie.source] != undefined) {
                    const today = moment(new Date(), config.format.date);
                    const currentYear = today.year();
                    const thisFinancialYear = moment(`${currentYear}-07-01`);
                    const lastFinancialYear = moment(`${currentYear - 1}-07-01`);

                    uie.disabled = false;
                    // 判断逻辑
                    if (data.data[uie.source] < lastFinancialYear) {
                      // 肯定不能编辑
                      uie.disabled = true;
                    } else if (today.isSameOrAfter(thisFinancialYear)) {
                      // 今天大于今年的7月1日, 在今年7月1日的财年
                      if (data.data[uie.source].isSameOrAfter(thisFinancialYear)) {
                      } else {
                        uie.disabled = true;
                      }
                    } else if (today.isSameOrAfter(lastFinancialYear)) {
                      // 否则今天大于去年的7月1日, 在去年7月1日的财年
                      if (data.data[uie.source].isSameOrAfter(lastFinancialYear)) {
                      }
                    }
                  }

                  break;
                case 'TimePicker':
                  if (uie.component === 'TimePicker') {
                    switch (uie.type) {
                      case 'RangePicker':
                        if (data.data[uie.source] !== null && data.data[uie.source] !== undefined && !globalFunction.isNullOrEmpty(data.data[uie.source])) {
                          let time = data.data[uie.source].split(',').map(item => {
                            if (item !== null && item !== undefined) {
                              return moment(item, 'HH:mm');
                            } else {
                              return undefined;
                            }
                          });
                          data.data[uie.source] = time;
                        } else {
                          data.data[uie.source] = undefined;
                        }
                        break;
                      default:
                        if (data.data[uie.source] !== null && data.data[uie.source] !== undefined) {
                          data.data[uie.source] = moment(data.data[uie.source], 'HH:mm');
                        } else {
                          data.data[uie.source] = undefined;
                        }
                        break;
                    }
                  }
                  break;
                case 'DateTimePicker':
                  if (data.data[uie.source] !== null && data.data[uie.source] !== undefined) {
                    data.data[uie.source] = moment(data.data[uie.source], config.component.DatePicker.dateTimeFormat);
                  } else {
                    data.data[uie.source] = undefined;
                  }
                  break;
                case 'Select':
                  //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                  if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                    if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                      data.data[uie.source] = componentDataSource[uie.source][0].Value;
                    }
                    if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                      data.data[uie.source] = [];
                    }
                  }
                  if (uie.autoSelect) {
                    //如果是自定义AutoSelect的类型, 触发其onChange事件
                    operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: data.data[uie.source], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                  }
                  break;
                case 'RichTextEditor':
                  //处理RichTextEditor, 如果是null或者undefined，改为空字符串，否则会崩溃
                  if (data.data[uie.source] === null) {
                    data.data[uie.source] = '';
                  }
                  break;
                case 'Input':
                case 'AutoComplete':
                  //处理Input, 如果type是fileName, 处理成改文件名的状态
                  if (uie.type === 'fileName') {
                    uie.addonAfter = globalFunction.getExtension(data.data[uie.source]);
                    data.data[uie.source] = globalFunction.getFileNameWithoutExtension(data.data[uie.source]);
                  }
                  break;
                case 'ColorPicker':
                  if (data.data[uie.source] === null) {
                    data.data[uie.source] = config.component.ColorPicker.defaultColor
                  }
                  break;
              }
            });
          });

          //把处理后的数据赋值给表单
          switch (sectionComponent.state.section.name) {
            case 'Invoice':
              data.data.InvoiceLineItemList.map(lineItem => {
                if (lineItem.FeeTypeId === null) {
                  lineItem.FeeTypeId = 0;
                }
                if ((pageComponent.props.authUser.CompanyId == 3) && lineItem.CompanyOfficeId === null) {
                  lineItem.CompanyOfficeId = 0;
                }
                if (lineItem.Tax === 0) {
                  let accountCode = pageComponent.state.accountCode.filter(c => c.Value === lineItem.AccountCode);
                  if (accountCode.length > 0) {
                    if (accountCode[0].Data) {
                      lineItem.Tax = 1;
                    } else {
                      lineItem.Tax = 0;
                    }
                  }
                }
                return lineItem;
              })
              const hasPayment = parameter.HasPayment === true || data.data.AmountPaid > 0;
              data.data.HasPayment = hasPayment;
              // 有付款记录的 Invoice 只允许高权限用户修改逾期通知开关，避免整单及 Lines 被改动。
              if (hasPayment) {
                const editComponent = sectionComponent.props.section.componentList.find(c => c.type === 'Edit');
                const hasOverdueNotificationComponent = editComponent?.groupList?.some(group =>
                  group.uieList?.some(uie => uie.source === 'DisableOverDueInvoiceNotifition')
                ) === true;
                const canEditOverdueNotification = pageComponent.props.authUser?.MaxPermissionLevel >= 98
                  && hasOverdueNotificationComponent;
                sectionComponent.setState({
                  formReadOnly: true,
                  formReadOnlyEditableSources: canEditOverdueNotification ? ['DisableOverDueInvoiceNotifition'] : []
                });
              }
              break;
            case 'Quote':
              data.data.QuoteLineItemList.map(lineItem => {
                if (lineItem.FeeTypeId === null) {
                  lineItem.FeeTypeId = 0;
                }
                if (lineItem.Tax === 0) {
                  let accountCode = pageComponent.state.accountCode.filter(c => c.Value === lineItem.AccountCode);
                  if (accountCode.length > 0) {
                    if (accountCode[0].Data) {
                      lineItem.Tax = 1;
                    } else {
                      lineItem.Tax = 0;
                    }
                  }
                }
                return lineItem;
              })
              break;
          }

          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data, currentDataKey: data.data.key });
          sectionComponent.setState({ dataLoading: false });
          let functionName = 'edit' + sectionName + 'PopUpRun';
          try {
            if (typeof sections[sectionName][functionName] === 'function') {
              sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie, data: data.data });
            }
          } catch (error) { }

          sectionComponent.setState({ isFormModified: false });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

//通用的点击删除按钮逻辑, 弹出提示, 确认后删除并刷新Section
function deleteBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的点击删除按钮逻辑');
  httpClient
    .delete(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
        let functionName = 'delete' + sectionName + 'Run';
        try {
          if (typeof sections[sectionName][functionName] === 'function') {
            sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
          }
        } catch (error) { }
      } else {
        if (data.code === 2) {
          message.error(data.message);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//通用的排序, 后台返回成功信息后刷新Section
function sortBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  console.log('通用的排序逻辑');
  httpClient
    .post(pageComponent.props.areaName + '/' + sectionName + '/Sort', parameter)
    .then(({ data }) => {
      if (data.result) {
        // 无需刷新, 直接用内存里的变量
        // sectionComponent.getSectionDataByDefault();
        let functionName = 'sort' + sectionName + 'Run';
        try {
          if (typeof sections[sectionName][functionName] === 'function') {
            sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie, data: data.data });
          }
        } catch (error) { }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//通用的点击提交自定义表单按钮逻辑, 提交绑定的form
function submitCustomForm({ parameter, sectionComponent, pageComponent, sectionName } = {}) {
  let canSubmit = true;
  let errorInfo = '';
  let formRef = sectionComponent.customForm.current?.formRef.current;

  // 单字段专用保存不应被 Invoice 其他必填项或 Lines 校验阻塞。
  if (sectionName === 'Invoice'
    && sectionComponent.state.componentType === 'Edit'
    && sectionComponent.customForm.current?.state.formData?.HasPayment === true
    && sectionComponent.state.formReadOnlyEditableSources.includes('DisableOverDueInvoiceNotifition')) {
    updatePaidInvoiceOverdueNotification({
      parameter: sectionComponent.customForm.current?.props.defaultFormData,
      formComponent: sectionComponent.customForm.current,
      sectionComponent: sectionComponent,
      pageComponent: pageComponent,
      sectionName: sectionName
    });
    return;
  }

  // Lines 的 Description 为空时不参与表单校验，避免自动新增的空白行阻塞提交。
  if (sectionName === 'Invoice' || sectionName === 'Quote') {
    let lineItemFieldName = sectionName === 'Invoice' ? 'InvoiceLineItemList' : 'QuoteLineItemList';
    let lineItemList = formRef?.getFieldValue(lineItemFieldName);
    if (lineItemList !== undefined) {
      let validLineItemList = lineItemList.filter(lineItem => lineItem?.Description?.trim());
      formRef?.setFieldsValue({ [lineItemFieldName]: validLineItemList.length > 0 ? validLineItemList : undefined });
    }
  }
  //处理RichTextEditor必填却没填的情况
  sectionComponent.props.section.componentList.filter(c => c.type === sectionComponent.state.componentType)[0].groupList.forEach(group => {
    group.uieList.forEach(uie => {
      switch (uie.component) {
        case 'RichTextEditor':
          if (uie.required && globalFunction.isNullOrEmpty(sectionComponent.customForm.current?.formRef.current?.getFieldValue(uie.source))) {
            errorInfo += uie.source + ' can not be empty.\r\n';
            canSubmit = false;
          }
          break;
      }
    });
  });
  if (canSubmit) {
    sectionComponent.customForm.current?.submitForm();
  } else {
    message.error(errorInfo);
  }
}

//通用的提交自定义表单, 表单验证通过后在这里执行提交, 后台返回结果后刷新Section
function customFormOnSubmit({ parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ customFormSubmitting: true });
  let areaName = sectionComponent.props.areaName;
  let pageName = sectionComponent.props.pageName;
  let form = formComponent.formRef.current?.getFieldsValue();

  if ((pageComponent.props.pageName == 'JobDataTemplateDetail' || pageComponent.props.pageName == 'ClientJobTemplateDetail') && sectionName == 'Document') {
    areaName = 'Business';
  }

  switch (sectionName) {
    case 'Quote':
      //判断Quote附加表单是否有至少一条数据
      if (form.QuoteLineItemList === null || form.QuoteLineItemList === undefined || form.QuoteLineItemList.length === 0) {
        message.error('Quote lines can not be empty.');
        sectionComponent.setState({ customFormSubmitting: false });
        return false;
      }
      break;
    case 'Invoice':
      //判断Invoice附加表单是否有至少一条数据, 三个联系人输入框至少填了一个
      if (form.InvoiceLineItemList === null || form.InvoiceLineItemList === undefined || form.InvoiceLineItemList.length === 0) {
        message.error('Invoice lines can not be empty.');
        sectionComponent.setState({ customFormSubmitting: false });
        return false;
      }
      if (globalFunction.isNullOrEmpty(form.ContactFirstName) && globalFunction.isNullOrEmpty(form.ContactLastName) && globalFunction.isNullOrEmpty(form.ContactCompany)) {
        message.error('Company, fisrt name and last name can not be all empty.');
        sectionComponent.setState({ customFormSubmitting: false });
        return false;
      }
      if (pageComponent.state.jobData.ModuleConfig.CopyQuoteToInvoiceAutoAccept == true) {
        form['QuoteId'] = pageComponent.state.addFromQuoteId;
      }
      break;
    case 'JobTask':
      //判断Task必须选了user或者team
      console.log(form.AssignedUserId, form.AssignedUserIds, form.AssignedTeamId);
      if ((form.AssignedUserId === undefined || form.AssignedUserId === 0) && (form.AssignedUserIds === undefined || form.AssignedUserIds.length === 0) && (form.AssignedTeamId === undefined || form.AssignedTeamId === 0)) {
        message.error('Please assign the task to a user or a team.');
        sectionComponent.setState({ customFormSubmitting: false });
        return false;
      }
      //追加选择的Document
      form.DocumentList = pageComponent.state.selectedDocumentList;
      break;
  }

  formComponent.props.component.groupList.filter(c => c.show).forEach(group => {
    group.uieList.forEach(uie => {
      if (uie.component === 'DatePicker') {
        if (form[uie.source] !== undefined && form[uie.source] !== null) {
          form[uie.source] = moment(form[uie.source]).format(config.format.sqlDate);
        } else {
          form[uie.source] = null;
        }
      }
      if (uie.component === 'ColorPicker') {
        if (form[uie.source] !== undefined) {
          form[uie.source] = form[uie.source].hex
        } else {
          form[uie.source] = null;
        }
      }
      if (uie.component === 'TimePicker') {
        if (form[uie.source] !== undefined && form[uie.source] !== null) {
          switch (uie.type) {
            case 'RangePicker':
              if (form[uie.source][0] !== undefined && form[uie.source][0] !== null && form[uie.source][1] !== undefined && form[uie.source][1] !== null) {
                let time = moment(form[uie.source][0]).format('HH:mm') + ',' + moment(form[uie.source][1]).format('HH:mm');
                form[uie.source] = time;
              } else {
                form[uie.source] = null;
              }
              break;
            default:
              form[uie.source] = moment(form[uie.source]).format('HH:mm');
              break;
          }
        } else {
          form[uie.source] = null;
        }
      }
      if (uie.component === 'DateTimePicker') {
        if (form[uie.source] !== undefined && form[uie.source] !== null) {
          form[uie.source] = moment(form[uie.source]).format(config.component.DatePicker.dateTimeFormat);
        } else {
          form[uie.source] = null;
        }
      }
      if (uie.component === 'InputNumber') {
        if (uie.type !== 'byte' && uie.type !== 'positiveInteger' && (sectionName === 'Job' || sectionName === 'Property') && form[uie.source] === null) {
          form[uie.source] = -2147483648;
        }
      }
    });
  });

  if (parameter !== undefined) {
    for (let key in parameter) {
      form[key] = parameter[key];
    }
  }

  //处理一些特殊的自定义字段
  form['Notify'] = formComponent.formRef.current?.getFieldValue('Notify');
  //Cancel Inspection Notification 弹框设置的两个字段 (SubJob Edit), 未在 XML 注册, 单独抓值
  form['NotifyCancelInspectionEmail'] = formComponent.formRef.current?.getFieldValue('NotifyCancelInspectionEmail');
  form['NotifyCancelInspectionSMS'] = formComponent.formRef.current?.getFieldValue('NotifyCancelInspectionSMS');

  form.key = formComponent.state.currentDataKey;
  console.log(sectionComponent.state.componentType + ' 提交的表单', form);

  switch (sectionComponent.state.componentType) {
    case 'Create':
      httpClient
        .post(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            customFormFinish({ data: data.data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
            if (data.code === 2) {
              message.info(data.message);

              switch (sectionComponent.state.section.name) {
                case 'SubJob':
                  globalFunction.getSectionComponent(pageComponent, 'Approval').getSectionDataByDefault();
                  break;
              }
            }
          } else {
            if (data.code === 2) {
              message.error(data.message);
              sectionComponent.setState({ customFormSubmitting: false });
            } else {
              globalFunction.handleResultError(data, pageComponent);
              sectionComponent.setState({ customFormSubmitting: false });
            }
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
    case 'Edit':
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            customFormFinish({ data: data.data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
            if (data.code === 2) {
              message.info(data.message);
            }
          } else {
            if (data.code === 2) {
              message.error(data.message);
              sectionComponent.setState({ customFormSubmitting: false });
            } else {
              globalFunction.handleResultError(data, pageComponent);
              sectionComponent.setState({ customFormSubmitting: false });
            }
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ customFormSubmitting: false });
        });
      break;
  }
}

function updatePaidInvoiceOverdueNotification({ parameter, formComponent, sectionComponent, pageComponent, sectionName } = {}) {
  sectionComponent.setState({ customFormSubmitting: true });
  const form = formComponent.formRef.current?.getFieldsValue();
  httpClient
    .put(sectionComponent.props.areaName + '/Invoice/UpdateDisableOverDueInvoiceNotifition', {
      InvoiceId: formComponent.state.currentDataKey,
      DisableOverDueInvoiceNotifition: form?.DisableOverDueInvoiceNotifition === true
    })
    .then(({ data }) => {
      if (data.result) {
        customFormFinish({ data: data.data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName });
      } else {
        globalFunction.handleResultError(data, pageComponent);
        sectionComponent.setState({ customFormSubmitting: false });
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      sectionComponent.setState({ customFormSubmitting: false });
    });
}

//添加或修改完成，处理后续重置按钮或刷新Section等事宜
function customFormFinish({ data, parameter, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (formComponent.props.component.onSubmitFinish !== null) {
    if (typeof sections[sectionName][formComponent.props.component.onSubmitFinish] === 'function') {
      sections[sectionName][formComponent.props.component.onSubmitFinish]({ parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
    }
  }

  switch (sectionComponent.state.section.name) {
    case 'JobTask':
      // 编辑任务后，Job 的 CompanyUserName 可能已因 Technical team 联动更新，立即刷新 Job Section。
      if (sectionComponent.state.componentType === 'Edit'&& Number(pageComponent?.props?.authUser?.CompanyId) === 31) {
        globalFunction.getSectionComponent(pageComponent, 'Job')?.getSectionDataByDefault();
      }
      break;
    case 'AssessmentChecklistTemplate':
      sections['AssessmentChecklistTemplate']['refreshData']({ parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
      break;
    case 'JobAssessmentChecklist':
      sections['JobAssessmentChecklist']['refreshData']({ parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
      break;
    case 'CompanyTeam':
      //保存关闭弹窗前先清空成员多选, 避免下次打开弹窗时残留上一次勾选造成页面闪一下
      formComponent.additionalFormRef.current?.child.current?.setState({ selectedRowKeys: [], companyTeamMemberList: [] });
      break;
    case 'WorkflowStatusPreset':
      // 保存成功关闭前同步清空，下一次打开时不显示上一个 Preset 的残留状态。
      sections['WorkflowStatusPreset']['clearWorkflowStatusPresetSelection']({
        formComponent: formComponent,
        sectionComponent: sectionComponent,
      });
      break;
  }

  sectionComponent.setState({ customFormSubmitting: false });
  setTimeout(() => {
    if (sectionComponent.state.closeModelAfterSubmit !== false) {
      formComponent.resetFields();
      sectionComponent.setState({ showModal: false });
    }
    setTimeout(() => {
      if (formComponent.additionalFormRef.current !== null) {
        if (formComponent.formRef.current?.getFieldValue('QuoteLineItemList') !== undefined) {
          formComponent.formRef.current?.setFieldValue('QuoteLineItemList', undefined);
        }
        if (formComponent.formRef.current?.getFieldValue('InvoiceLineItemList') !== undefined) {
          formComponent.formRef.current?.setFieldValue('InvoiceLineItemList', undefined);
        }
      }
      if (formComponent.props.component.refreshDataFunction !== null && typeof sections[sectionName][formComponent.props.component.refreshDataFunction] === 'function') {
        sections[sectionName][formComponent.props.component.refreshDataFunction]({ data, parameter: parameter, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
      } else {
        sectionComponent.getSectionDataByDefault();
      }

      const preserveJobApprovedDocGroup = sectionName === 'JobApprovedDoc'
        && sectionComponent.state.closeModelAfterSubmit === false;
      const formRef = formComponent.formRef?.current;
      const group = preserveJobApprovedDocGroup ? formRef?.getFieldValue('Group') : undefined;
      formComponent.resetFields();
      if (preserveJobApprovedDocGroup && group !== undefined) {
        formRef?.setFieldValue('Group', group);
      }
      if (sectionComponent.state.closeModelAfterSubmit === false) {
        //连续添加的特殊后续处理
        switch (sectionComponent.state.section.name) {
          case 'JobTask':
            pageComponent.setState({ selectedDocumentList: [] });
            formComponent.formRef.current?.setFieldsValue({ TaskTemplateId: 0, AssignedUserId: 0, AssignedTeamId: 0, JobAssignedUserId: 0, JobWorkflowStatusId: 0, NoteTemplateId: 0 });
            message.success('Task Added');
            break;
        }
      }
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//通用的取消自定义表单
function cancelCustomForm({ parameter, sectionComponent, pageComponent, uie } = {}) {
  // 关闭时保留 Create/Edit 类型，避免 Modal 在关闭这一帧失去配置宽度并回退到默认宽度。
  // 下次打开时 createCustomForm/editCustomForm 会重新设置 componentType。
  sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false });
  setTimeout(() => {
    sectionComponent.customForm.current?.resetFields();
  }, config.setTimeoutMilliSecond);

  let sectionName = sectionComponent.props.section?.name;
  if (sectionName) {
    let functionName = 'cancel' + sectionName + 'PopUpRun';
    try {
      if (typeof sections[sectionName][functionName] === 'function') {
        sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
      }
    } catch (error) { }
  }
}

//通用的获取AutoComplete数据, 通过配置指定触发查询的最小字符数
export function getAutoCompleteData({ parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?key=' + parameter)
      .then(({ data }) => {
        if (data.result) {
          let componentDataSource = { ...sectionComponent.state.componentDataSource };
          componentDataSource[uie.source] = data.data;
          sectionComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//行内编辑：把单个被编辑字段的控件值, 转换成后端可接受的格式(与 customFormOnSubmit 的转换规则保持一致)
function formatInlineValue(uie, value, sectionName) {
  switch (uie.component) {
    case 'DatePicker':
      return value !== undefined && value !== null ? moment(value).format(config.format.sqlDate) : null;
    case 'DateTimePicker':
      return value !== undefined && value !== null ? moment(value).format(config.component.DatePicker.dateTimeFormat) : null;
    case 'TimePicker':
      if (value === undefined || value === null) return null;
      if (uie.type === 'RangePicker') {
        if (value[0] !== undefined && value[0] !== null && value[1] !== undefined && value[1] !== null) {
          return moment(value[0]).format('HH:mm') + ',' + moment(value[1]).format('HH:mm');
        }
        return null;
      }
      return moment(value).format('HH:mm');
    case 'ColorPicker':
      return value !== undefined && value !== null ? (value.hex !== undefined ? value.hex : value) : null;
    case 'InputNumber':
      //与弹窗一致：Job/Property 的可空数值字段, null 用哨兵值表示"清空"
      if (uie.type !== 'byte' && uie.type !== 'positiveInteger' && (sectionName === 'Job' || sectionName === 'Property') && (value === null || value === undefined)) {
        return -2147483648;
      }
      return value;
    default:
      return value;
  }
}

//行内编辑保存：用弹窗同一个可编辑 GET 取回完整可编辑记录, 只覆盖被编辑的那个字段后整体 PUT, 避免漏字段导致后端无条件赋值的日期字段被清空
export function inlineEditSave({ editUie, value, record, viewComponent, pageComponent, onSuccess, onError } = {}) {
  let areaName = viewComponent.props.areaName;
  let sectionName = viewComponent.props.section?.name || viewComponent.props.sectionName;
  let key = record?.key ?? viewComponent.state.data?.key;

  //第一步：取回与弹窗编辑完全一致的可编辑记录(保证 payload 字段集与弹窗 PUT 相同)
  httpClient
    .get(areaName + '/' + sectionName + '/' + key)
    .then(({ data }) => {
      if (!data.result) {
        globalFunction.handleResultError(data, pageComponent);
        if (onError) onError();
        return;
      }
      let form = data.data;
      //仅转换被编辑字段, 其余字段保持可编辑 GET 原值(后端可直接回写)
      form[editUie.source] = formatInlineValue(editUie, value, sectionName);
      form.key = key;

      //第二步：整体 PUT(复用弹窗同一接口与业务逻辑)
      httpClient
        .put(areaName + '/' + sectionName, form)
        .then(({ data }) => {
          if (data.result) {
            if (data.code === 2 && data.message) {
              message.info(data.message);
            }
            //刷新该 section, 同步 jobData 及联动的显示名/工作流等; 等新数据回来后再回调(让行内编辑保持到刷新完成, 避免先显示旧值再跳成新值)
            viewComponent.getSectionDataByDefault(() => {
              if (onSuccess) onSuccess();
            });
          } else {
            if (data.code === 2) {
              message.error(data.message);
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
            if (onError) onError();
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          if (onError) onError();
        });
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      if (onError) onError();
    });
}

//通用的获取uie数据源数据
export function getUieDataSource({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (uie.autoDataSource && uie.datasourceUrl !== null) {
    let params = {};
    parameter.forEach(item => {
      params[item.key] = item.value;
    })

    httpClient
      .get(uie.datasourceUrl, { params })
      .then(({ data }) => {
        if (data.result) {
          if (data.data.length > 0) {
            let dataSource = data.data;
            let componentDataSource = { ...component.state.componentDataSource };
            if (uie.required) {
              dataSource = dataSource.filter(item => item.Value !== 0);
            }
            componentDataSource[uie.source] = dataSource;
            component.setState({ componentDataSource });
            setTimeout(() => {
              let formData = { ...component.state.formData };
              if (uie.autoSelect && dataSource.length > 0) {
                //如果是自定义AutoSelect的类型, 触发其onChange事件
                if (formData[uie.source] === null || formData[uie.source] === undefined) {
                  switch (uie.source) {
                    case 'UserState':
                      operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: 0, data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                      break;
                    case 'AssignedUserId':
                      //如果不是MyJob页面，才自动选择第一个选项
                      if (pageComponent.state.searchParameter.MyJob === undefined) {
                        operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: dataSource[0].Value, data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                      } else {
                        operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: pageComponent.props.authUser.CompanyUserId, data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                      }
                      break;
                    default:
                      if (uie.className?.indexOf('filter-select') === 0 && sectionComponent?.state?.section?.autoLoad) {
                        operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: dataSource[0].Value, data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie, loadData: false });
                      } else {
                        operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: dataSource[0].Value, data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                      }
                      // operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: dataSource[0].Value, data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                      break;
                  }
                }
              } else {
                //否则给普通的Select设置默认值, 为第一个选项
                if (uie.component === 'Select' && uie.type !== 'multiple' && dataSource.length > 0) {
                  if (formData[uie.source] === null || formData[uie.source] === undefined) {
                    if (uie.type === 'group') {
                      let dataSourceFilter = dataSource.filter(group => {
                        return group.SelectOptionList !== null && group.SelectOptionList.length > 0;
                      });
                      if (dataSourceFilter.length > 0 && uie.required) {
                        component.formRef.current?.setFieldValue(uie.source, dataSourceFilter[0].SelectOptionList[0].Value);
                      } else {
                        component.formRef.current?.setFieldValue(uie.source, dataSource[0].Value);
                      }
                    } else {
                      component.formRef.current?.setFieldValue(uie.source, dataSource[0].Value);
                    }
                  }
                  setTimeout(() => {
                    if (uie.onChange !== null && uie.source !== 'ScheduledTimeAmPm') {
                      operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: component.formRef.current?.getFieldValue(uie.source), data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                    }
                  }, config.setTimeoutMilliSecond);
                }
              }
            }, config.setTimeoutMilliSecond);
          }
          let functionName = 'get' + uie.source + 'DataSourceRun';
          try {
            if (typeof sections[sectionName][functionName] === 'function') {
              sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName });
            }
          } catch (error) { }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//通用的获取component数据源组
export function getComponentDataSourceGroup({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent } = {}) {
  let parameterStr = '';
  parameter.forEach(item => {
    parameterStr += item.key + '=' + item.value + '&';
  })

  httpClient
    .get(component.props.component.datasourceUrl + '?' + parameterStr)
    .then(({ data }) => {
      sectionComponent.setState({ renderForm: true });
      let componentDataSource = component.state.componentDataSource;
      if (data.result) {
        if (data.data.length > 0) {
          data.data.map((hash, i) => {
            let dataSource = hash.Value;
            let uie = null;
            component.props.component.groupList.filter(c => c.show).map((group, j) => {
              group.uieList.map((u, k) => {
                if (u.source == hash.Key) {
                  uie = u;
                }
              })
            })
            if (uie !== null) {
              if (uie.required) {
                dataSource = dataSource.filter(item => item.Value !== 0);
              }
              componentDataSource[hash.Key] = dataSource;
              setTimeout(() => {
                if (uie.autoSelect) {
                  //如果是自定义AutoSelect的类型, 触发其onChange事件
                  operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: dataSource[0].Value, formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                } else {
                  //否则给普通的Select设置默认值, 为第一个选项
                  if (uie.component === 'Select' && (uie.type === null || uie.type.indexOf('multiple') < 0)) {
                    let formData = { ...component.state.formData };
                    if (formData[uie.source] === null || formData[uie.source] === undefined) {
                      component.formRef.current?.setFieldValue(uie.source, dataSource[0]?.Value);
                    }
                    setTimeout(() => {
                      if (uie.onChange !== null && uie.source !== 'ScheduledTimeAmPm') {
                        operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: component.formRef.current?.getFieldValue(uie.source), data: dataSource[0], formComponent: formComponent, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                      }
                    }, config.setTimeoutMilliSecond);
                  }
                }
              }, config.setTimeoutMilliSecond)
            }
          });
          component.setState({ componentDataSource });
          let functionName = 'get' + sectionName + 'ComponentDataSourceGroupRun';
          try {
            if (typeof sections[sectionName][functionName] === 'function') {
              sections[sectionName][functionName]({ parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName });
            }
          } catch (error) { }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//打开发邮件界面
export function sendEmail({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent, invoiceId } = {}) {
  // invoiceId 仅在 Invoice MailMerge 发信场景传入；其它场景为 null，发信界面沿用 Job 类型 EmailTemplate
  pageComponent.setState({ sendEmailShow: true, selectedDocumentList: [], selectedDocumentTotalSize: 0, sendEmailInvoiceId: invoiceId ?? null, sendEmailSource: null });
  setTimeout(() => {
    if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ModuleConfig.FromEmailAddress)) {
      pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldsValue({ From: 'My Email' });
    }
  }, config.setTimeoutMilliSecond);

  let selectedEmailList = [];
  if (sectionComponent !== undefined && sectionComponent !== null && sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    sectionComponent.child.current?.state.data.forEach((item) => {
      if (sectionComponent.child.current?.state.selectedRowKeys.indexOf(item.key) >= 0) {
        if (item.Email != null) {
          item.Email.split(',').map(email => {
            if (selectedEmailList.indexOf(email.trim()) < 0 && email.trim() !== '') {
              selectedEmailList.push(email.trim());
            }
          })
        }
      }
    });
  }

  if (pageComponent.props.authUser.EmailSignature !== null) {
    setTimeout(() => {
      setEmailDefaultInfo(parameter, pageComponent)
      if (sectionComponent !== undefined && sectionComponent !== null && sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
        pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldsValue({ To: selectedEmailList });
        sectionComponent.child.current?.setState({ selectedRowKeys: [] });
        sectionComponent.child.current?.getSectionDataByDefault();
      }
    }, config.setTimeoutMilliSecond);
  } else {
    httpClient
      .get('Admin/CompanyUser/' + pageComponent.props.authUser.CompanyUserId)
      .then(({ data }) => {
        if (data.result) {
          pageComponent.props.authUser.EmailSignature = data.data.EmailSignature;
          pageComponent.props.setAuthUser(pageComponent.props.authUser);
          setTimeout(() => {
            setEmailDefaultInfo(parameter, pageComponent);
            if (sectionComponent !== undefined && sectionComponent !== null && sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
              pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldsValue({ To: selectedEmailList });
              sectionComponent.child.current?.setState({ selectedRowKeys: [] });
              sectionComponent.child.current?.getSectionDataByDefault();
            }
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function setEmailDefaultInfo(parameter, pageComponent) {
  pageComponent.sendEmail.current?.getSubject();
  pageComponent.sendEmail.current?.getCompanyEmailTemplate();
  pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldsValue({ To: [], CC: [], BCC: [], Subject: '', Body: pageComponent.props.authUser.EmailSignature !== null ? pageComponent.props.authUser.EmailSignature : '' });
  if (!globalFunction.isNullOrEmpty(parameter.Email)) {
    pageComponent.sendEmail.current?.sendEmailFormRef.current?.setFieldValue('To', parameter.Email.split(',').map(item => item.trim()));
  }
}

//打开发短信界面
export function sendSMS({ parameter, sectionName, component, formComponent, sectionComponent, pageComponent } = {}) {
  pageComponent.setState({ sendSMSShow: true });
  setTimeout(() => {
    pageComponent.sendSMS.current?.setState({ parameter: parameter });
  }, config.setTimeoutMilliSecond);
}

//Suburb控件 找自动Suburb和Postcode
export function searchSuburbChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&state=' + pageComponent.state.state)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((suburb, j) => {
            options.push({ label: suburb.Name + ' (' + suburb.Postcode + ')', value: suburb.Name + ' (' + suburb.Postcode + ')', data: suburb });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//Suburb 选择后快速填写数据
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('Suburb', data.data.Name);
  formComponent.formRef.current?.setFieldValue('Postcode', data.data.Postcode);
}

//PostalSuburb 选择后快速填写数据
export function searchPostalSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('PostalSuburb', data.data.Name);
  formComponent.formRef.current?.setFieldValue('PostalPostcode', data.data.Postcode);
}

export function getStatsDataByDefault({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  sectionComponent.getStatsDataByDefault();
}

export function getChartDataByDefault({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  sectionComponent.getChartDataByDefault();
}

export function getChartDataByQuoteConversion({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  sectionComponent.getChartDataByQuoteConversion();
}

export function getChartDataByEngagedJob({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  sectionComponent.getChartDataByEngagedJob();
}

export function showTruncate({ sectionName, parameter, formComponent, sectionComponent, pageComponent }) {
  let typeName = sectionComponent.state.section.type;
  switch (typeName) {
    default:
      let data = sectionComponent.child.current?.state.data.map((item, i) => {
        if (item.key === parameter.key) {
          item.showTruncate = true
          // item.showTruncate = !item.showTruncate  //点击后可进行缩放展示
        }
        return item
      });
      setTimeout(() => {
        sectionComponent.child.current?.setState({ data: [] });
        sectionComponent.child.current?.setState({ data });
      }, config.setTimeoutMilliSecond);
      break;
  }

}
